module.exports = __webpack_public_path__ + "img/hl4.beccfc18.png";